import axios from 'axios';
import {Actions as SelfAuthActions} from './selfAuthConstants';
import { showModal } from 'components/Modal/actions';
import { ModalStyle, ModalButtonStyle } from 'components/Modal';
import {translate} from 'utils/translateUtil';

export const validate = (params: object, config: any) => {
    const url = location.origin  + '/self-auth/validate';
    const headers = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
        'Access-Control-Allow-Methods': 'GET,OPTIONS',
        'Access-Control-Allow-Headers': '*'
    }
    return (dispatch: any) => {
        dispatch({
            type: SelfAuthActions.VALIDATE,
            payload: axios({
                method: 'post',
                headers,
                url,
                data:params
            }).then(data => {
                return new Promise((resolve, reject)=> {
                    dispatch(
                        showModal({
                            modalStyle: ModalStyle.success,
                            buttonStyle: ModalButtonStyle.confirm,

                            textHeadline: translate('modal.headline'),
                            textDescription: translate('modal.description'),
                            textConfirm: translate('modal.accept'),

                            onConfirm: () => {
                                if (data && data.headers) {
                                    window.location.href = config.url.olb_redirect;
                                }
                            }
                        })
                    );
                    return resolve(data)
                })
            }).catch(error => {
                return new Promise((resolve, reject)=> {
                    return reject(error)
                })
            })
        })
    }
}